import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { DotFitter } from '@sc/data-access-models';
import {
  DotFittersAddedAction,
  DotFittersClearedAction,
  DotFittersShowMoreAction,
} from './dotFitters.actions';

@State<DotFitter[]>({
  name: 'dotFitters',
  defaults: [],
})
@Injectable()
export class DotFittersState {
  @Action(DotFittersAddedAction)
  add(
    ctx: StateContext<DotFitter[]>,
    { dotFitters }: DotFittersAddedAction
  ): void {
    ctx.setState(dotFitters);
  }

  @Action(DotFittersClearedAction)
  clear(ctx: StateContext<DotFitter[]>): void {
    ctx.setState([]);
  }

  @Action(DotFittersShowMoreAction)
  showMore(ctx: StateContext<DotFitter[]>): void {
    ctx.setState(
      ctx
        .getState()
        .map((df) => ({ ...df, displayAppointments: df.cacheAppointments }))
    );
  }
}
